import { Helmet } from 'react-helmet-async';
import { useLanguage } from '@/contexts/LanguageContext';

const SITE_URL = 'https://tomartmask.cz';

const StructuredData = () => {
  const { lang, t } = useLanguage();

  const localBusiness = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': `${SITE_URL}/#business`,
    name: 'Tom Art Mask',
    image: `${SITE_URL}/og-image.jpg`,
    logo: `${SITE_URL}/logo.svg`,
    url: SITE_URL,
    telephone: '+420775291737',
    email: 'info@tomartmask.cz',
    description:
      lang === 'cs'
        ? 'Profesionální airbrush design hokejových masek na zakázku. 19+ let zkušeností.'
        : 'Professional custom airbrush hockey mask design. 19+ years of experience.',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Třebíč',
      addressCountry: 'CZ',
    },
    areaServed: [
      { '@type': 'Country', name: 'Czech Republic' },
      { '@type': 'Country', name: 'Slovakia' },
      { '@type': 'Country', name: 'Germany' },
      { '@type': 'Country', name: 'Austria' },
      { '@type': 'Place', name: 'Europe' },
    ],
    priceRange: '$$',
    sameAs: [
      'https://www.facebook.com/tomartmask',
      'https://www.instagram.com/tomartmask',
    ],
  };

  const product = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: lang === 'cs' ? 'Custom Airbrush Hokejová Maska' : 'Custom Airbrush Hockey Goalie Mask',
    image: `${SITE_URL}/og-image.jpg`,
    description:
      lang === 'cs'
        ? 'Originální airbrush design hokejové brankářské masky vytvořený na zakázku.'
        : 'Original custom airbrush design for hockey goalie masks.',
    brand: { '@type': 'Brand', name: 'Tom Art Mask' },
    offers: {
      '@type': 'AggregateOffer',
      priceCurrency: 'CZK',
      lowPrice: '8000',
      availability: 'https://schema.org/InStock',
      seller: { '@type': 'Organization', name: 'Tom Art Mask' },
    },
  };

  const faqPage = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: t.faq.items.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: { '@type': 'Answer', text: item.a },
    })),
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(localBusiness)}</script>
      <script type="application/ld+json">{JSON.stringify(product)}</script>
      <script type="application/ld+json">{JSON.stringify(faqPage)}</script>
    </Helmet>
  );
};

export default StructuredData;
